import React from 'react'
import { Select } from 'antd'
import styles from './styles.module.scss'

const { Option } = Select

interface PropTypes {
	onFilterChange: Function
}

const InvoicesHeader: React.FC<PropTypes> = ({ onFilterChange }) => {
	const handleFilterChange = (value: string) => {
		onFilterChange(value)
	}

	return (
		<header className={styles.invoicesHeader}>
			<div className={styles.invoicesHeader_title}>
				<h3>Invoices</h3>
			</div>
			<div className={styles.invoicesHeader_actions}>
				<Select onChange={handleFilterChange} placeholder='Filter'>
					<Option value='all'>All</Option>
					<Option value='yes'>Paid</Option>
					<Option value='no'>Unpaid</Option>
				</Select>
			</div>
		</header>
	)
}

export default InvoicesHeader
